import {
  objectNameById,
  objectById,
  objectNamesById,
  camelize,
  kvpsActiveInactive,
  setLocalStorage
} from 'src/utilities/utils'
import Vue from 'vue'
import hash from 'object-hash'
import _ from 'lodash'
import {make} from 'vuex-pathify'
import {crudifyMutations, byId, resetState, hydrateEdit} from 'src/utilities/vuex2'
import {ptracGetEntities} from 'src/utilities/ptracApi'
import {OK} from 'http-status-codes'
import Constants from '@/utilities/constants'

let initialState = {
  ui: {
    searchQuery: null,
    departmentName: null,
    taskTemplateName: null
  },
  results: [],
  edit: {
    id: null,
    name: null,
    key: null,
    taskTemplateId: null,
    departments: [],
    files: [],
    formFieldBlocks: [],
    repeatable: false,
    invoiceable: false,
    qbItemCodeId: null,
    active: true
  }
}

const state = Vue.util.extend({}, initialState)

const getters = make.getters(state)

getters.byId = byId
getters.kvpsForSelect = (state) => {
  return kvpsActiveInactive(state.results)
}
getters.kvpsForSelectByIds = (state) => (tasks) => {
  const kvps = []
  if (tasks && tasks.length > 0) {
    for (const task of tasks) {
      const taskName = objectById(state.all, task.nameId)
      const kvp = {
        label: taskName.name,
        value: task.id
      }
      kvps.push(kvp)
    }
  }
  return kvps
}

const mutations = make.mutations(state)
mutations.reset = resetState
mutations.hydrateEdit = hydrateEdit
crudifyMutations(mutations)

mutations.generateKey =(state) => {
  state.edit.key = camelize(state.edit.name)
}
mutations.resetEdit = (state) => {
  state.edit = {
    id: null,
    name: null,
    key: null,
    taskTemplateId: null,
    departments: [],
    files: [],
    formFieldBlocks: [],
    repeatable: false,
    invoiceable: false,
    qbItemCodeId: null,
    active: true
  }
}
mutations.appendPdfForm = (state, file) => {
  state.edit.files.push({
    fileId: file.id,
    name: file.name,
    path: file.path,
    sort: state.edit.files.length + 1
  })
}
mutations.removePdfForm = (state, fileToDelete) => {
  state.edit.files = _.filter(state.edit.files, (file) => hash(file) !== hash(fileToDelete))
}

mutations.appendFormFieldBlock = (state, formFieldBlock) => {
  const sort = (state.edit.formFieldBlocks.length * 100) + 100
  state.edit.formFieldBlocks.push({
    formFieldBlockId: formFieldBlock.id,
    sort
  })
}
mutations.removeFormFieldBlock = (state, formFieldBlockToDelete) => {
  state.edit.formFieldBlocks = _.filter(state.edit.formFieldBlocks, (formFieldBlock) => formFieldBlock.formFieldBlockId !== formFieldBlockToDelete.formFieldBlockId)
}
mutations.updateFormFieldBlocksSort = (state, sortedFieldBlocks) => {
  state.edit.formFieldBlocks.forEach((formFieldBlock) => {
    formFieldBlock.sort = sortedFieldBlocks[formFieldBlock.name]
  })
}
mutations.updateFormsSort = (state, sortedFiles) => {
  state.edit.files.forEach((file) => {
    file.sort = sortedFiles[file.name]
  })
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchAll({state, rootState}) {
      // need to include task template check because the code below is dependent on task templates being fully loaded
      // if (checkLocalStorage(state, Constants.LOCAL_STORAGE.LOCATION.TASK_NAMES, Constants.LOCAL_STORAGE.EXPIRATION.ONE_DAY)
      //   && checkLocalStorage({}, Constants.LOCAL_STORAGE.LOCATION.TASK_TEMPLATES, Constants.LOCAL_STORAGE.EXPIRATION.ONE_DAY)) {
      //   return
      // }

      const itemCodes = rootState.quickbooks.results
      const templates = rootState.tasks.templates.results
      const departments = rootState.departments.results

      const response = await ptracGetEntities('task-names/findAll')

      if (OK === response.status) {
        const taskNames = response.data

        const mergedTaskNames = []
        taskNames.forEach((taskName) => {
          const taskTemplateName = objectNameById(templates, taskName.taskTemplateId)

          let qbItemCode = null
          if (taskName.qbItemCodeId) {
            const itemCode = objectById(itemCodes, taskName.qbItemCodeId)
            if (itemCode) {
              qbItemCode = itemCode
              if (qbItemCode.active === false) {
                qbItemCode.name = qbItemCode.name + Constants.APPEND.INACTIVE
              }
            }
          }
          let departmentNames = objectNamesById(departments, taskName.departments)
          if (departmentNames.length > 0) {
            departmentNames = departmentNames.join(', ')
          } else {
            departmentNames = null
          }

          const tableFriendlyTaskName = {
            id: taskName.id,
            name: taskName.name,
            key: taskName.key,
            taskTemplateId: taskName.taskTemplateId,
            departments: taskName.departments,
            taskTemplateName: taskTemplateName,
            departmentNames: departmentNames,
            files: taskName.files,
            repeatable: taskName.repeatable,
            invoiceable: taskName.invoiceable,
            qbItemCode: qbItemCode ? qbItemCode.name : '',
            qbClass: qbItemCode ? qbItemCode.qbClass : '',
            active: taskName.active
          }
          mergedTaskNames.push(tableFriendlyTaskName)
        })

        state.results = mergedTaskNames
        setLocalStorage(Constants.LOCAL_STORAGE.LOCATION.TASK_NAMES, state.results)
      }
    },
    async fileInUse({}, file) {
      return await ptracGetEntities(`task-names/search/findByFiles?name=${file.name}&path=${encodeURI(file.path)}`)
    },
    async taskNamesByFileId({}, fileId) {
      return await ptracGetEntities(`task-names/search/findByFileId?id=${fileId}`)
    },
    async fetchByFormFieldBlockId({}, formFieldBlockId) {
      return await ptracGetEntities(`task-names/search/findByFormFieldBlockId?formFieldBlockId=${formFieldBlockId}`)
    },
    async fetchFindByItemCodeId({}, qbItemCodeId) {
      return await ptracGetEntities('task-names/search/findByQbItemCodeId?qbItemCodeId=' + qbItemCodeId)
    },
    async findByTaskTemplateId({}, taskTemplateId) {
      return await ptracGetEntities('task-names/search/findByTaskTemplateId?taskTemplateId=' + taskTemplateId)
    }
  }
}
